var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass",
    clipPath: "url(#clip0_127_38527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Primary",
    d: "M26.0234 13C26.0234 15.8687 25.0922 18.5188 23.5234 20.6688L31.4359 28.5875C32.2172 29.3687 32.2172 30.6375 31.4359 31.4188C30.6547 32.2 29.3859 32.2 28.6047 31.4188L20.6922 23.5C18.5422 25.075 15.8922 26 13.0234 26C5.84219 26 0.0234375 20.1812 0.0234375 13C0.0234375 5.81875 5.84219 0 13.0234 0C20.2047 0 26.0234 5.81875 26.0234 13ZM13.0234 22C14.2053 22 15.3757 21.7672 16.4676 21.3149C17.5595 20.8626 18.5517 20.1997 19.3874 19.364C20.2231 18.5282 20.8861 17.5361 21.3384 16.4442C21.7906 15.3522 22.0234 14.1819 22.0234 13C22.0234 11.8181 21.7906 10.6478 21.3384 9.55585C20.8861 8.46392 20.2231 7.47177 19.3874 6.63604C18.5517 5.80031 17.5595 5.13738 16.4676 4.68508C15.3757 4.23279 14.2053 4 13.0234 4C11.8415 4 10.6712 4.23279 9.57929 4.68508C8.48736 5.13738 7.4952 5.80031 6.65948 6.63604C5.82375 7.47177 5.16081 8.46392 4.70852 9.55585C4.25623 10.6478 4.02344 11.8181 4.02344 13C4.02344 14.1819 4.25623 15.3522 4.70852 16.4442C5.16081 17.5361 5.82375 18.5282 6.65948 19.364C7.4952 20.1997 8.48736 20.8626 9.57929 21.3149C10.6712 21.7672 11.8415 22 13.0234 22Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_38527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.0234375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.8e08304e9eee27cdb44ac0988af529b8.svg";
export { ForwardRef as ReactComponent };